module.exports = __webpack_public_path__ + "img/2025-1.e849ae0b.jpg";